// Passive label showing WHICH players were locked into the session at the
// moment this decision was generated. Extracted from DecisionEnginePage.js
// during Phase 1 consolidation — no logic or visual changes.
import React from 'react';
import { Lock } from 'lucide-react';

export const ContextProvenanceBadge = ({ context }) => {
  const ctx = context || {};
  const ids = Array.isArray(ctx.selected_player_ids) ? ctx.selected_player_ids : [];
  const names = Array.isArray(ctx.selected_player_names) ? ctx.selected_player_names : [];
  if (!ctx.sticky_enabled || ids.length === 0) return null;

  // Prefer stored names; fall back to short id fragment if names are missing.
  const display = ids.map((id, i) => (names[i] && names[i].trim()) || `#${(id || '').slice(0, 4)}`);
  const MAX_VISIBLE = 2;
  const visible = display.slice(0, MAX_VISIBLE);
  const overflow = display.length - visible.length;
  const label = visible.join(', ') + (overflow > 0 ? ` (+${overflow})` : '');

  return (
    <div
      className="flex items-center gap-1.5 text-[11px] text-gray-500 dark:text-gray-400 px-1"
      data-testid="context-provenance-badge"
      aria-label="Player context locked during this decision"
    >
      <Lock className="h-3 w-3 shrink-0" />
      <span className="font-medium text-gray-500 dark:text-gray-400">Context:</span>
      <span className="truncate" data-testid="context-provenance-names">{label}</span>
    </div>
  );
};
